<template>
	
	<div :class="{ 'stopwatch': true, 'stopwatch--small': small, 'stopwatch--floating': floating, 'stopwatch--floating-visible': floatingVisible }">
		
		<div class="button-wrapper">
			<el-button :type="buttonType" circle @click="toggleRecording"><ion-icon :name="buttonIcon"></ion-icon></el-button>
		</div>
		
		<p class="time">{{ $store.state.timebook.seconds | timeString }}</p>
		
		<el-input v-model="$store.state.timebook.description" placeholder="Automatic entry"></el-input>
		
		<el-row v-if="showDropdowns" class="dropdowns" :class="{ hidden: disableDropdowns }">
			
			<el-col :span="24">
				<el-select
					v-model="override_client_id"
					:disabled="disableDropdowns"
					size="mini"
					placeholder="Client"
					style="width: 100%;"
					:class="{ 'ten-margin-bottom': override_client_id }"
					no-data-text="No clients"
					@change="onChangeClient"
					@clear="onClearClient"
					clearable>
						<el-option v-for="item in $store.state.clients" :key="item.id" :label="item.name" :value="item.id">{{ item.name }}</el-option>
				</el-select>
			</el-col>
			
			<el-col :span="24">
				<el-select
					v-if="override_client_id"
					v-model="override_project_id"
					:disabled="disableDropdowns"
					size="mini" placeholder="Project"
					style="width: 100%;"
					:class="{ 'ten-margin-bottom': override_project_id }"
					no-data-text="No projects"
					@change="onChangeProject"
					@clear="onClearProject"
					clearable>
						<el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.id">{{ item.name }}</el-option>
				</el-select>
			</el-col>
			
			<el-col :span="24">
				<el-select
					v-if="override_project_id"
					v-model="override_ticket_id"
					:disabled="disableDropdowns"
					size="mini"
					placeholder="Task"
					style="width: 100%;"
					no-data-text="No tasks"
					@clear="onClearTicket"
					clearable>
						<el-option v-for="item in tickets" :key="item.id" :label="item.name" :value="item.id">{{ item.name }}</el-option>
				</el-select>
			</el-col>
			
		</el-row>
		
		<p v-if="description" v-html="description" class="description"></p>
		
	</div>
	
</template>

<script>
	
	export default {
		
		data() {
			
			return {
				
				projects: [],
				tickets: [],
				
				override_client_id: null,
				override_project_id: null,
				override_ticket_id: null,
				
			};
			
		},
		
		props: {
			
			small: { default: false },
			floating: { default: false },
			floatingVisible: { default: false }, 
			
			showDropdowns: { default: false },
			
			ticket: { default: function() { return {}; } },
			
			client_id: { default: null },
			project_id: { default: null },
			ticket_id: { default: null },
			
			project_name: { default: "" },
			
		},
		
		computed: {
			
			clientId() {
				if (this.override_client_id) {
					return this.override_client_id;
				} else if (this.client_id) {
					return this.client_id;
				}
				return this.$store.state.timebook.client_id;
			},
			
			projectId() {
				if (this.override_project_id) {
					return this.override_project_id;
				} else if (this.project_id) {
					return this.project_id;
				}
				return this.$store.state.timebook.project_id;
			},
			
			ticketId() {
				if (this.override_ticket_id) {
					return this.override_ticket_id;
				} else if (this.ticket_id) {
					return this.ticket_id;
				}
				return this.$store.state.timebook.ticket_id;
			},
			
			disableDropdowns() {
				return this.$store.state.timebook.ticket.hasOwnProperty("id");
			},
			
			buttonType() {
				return this.$store.state.timebook.recording ? "danger" : "success";
			},
			
			buttonIcon() {
				return this.$store.state.timebook.recording ? "close" : "play";
			},
			
			description() {
				if (this.$store.state.timebook.recording) {
					if (this.$store.state.timebook.ticket.id) {
						if (this.ticket_id == this.$store.state.timebook.ticket.id) {
							return "You are working on this task";
						}
						return "You are working on <strong>" + this.$store.state.timebook.ticket.project.name + ": " + this.$store.state.timebook.ticket.name + "</strong>";
					}
					return false;
				}
				return false;
			}
			
		},
		
		methods: {
			
			onClearClient() {
				this.override_client_id = null;
				this.override_project_id = null;
				this.override_ticket_id = null;
			},
			
			onClearProject() {
				this.override_project_id = null;
				this.override_ticket_id = null;
			},
			
			onClearTicket() {
				this.override_ticket_id = null;
			},
			
			onChangeProject(id) {
				
				// Reset tickets.
				
				this.tickets = [];
				
				// Find this project's tickets.
				
				this.projects.map((data, i) => {
					if (data.id == id) {
						this.axios.get("projects/" + data.slug).then((response) => {
							this.tickets = response.data[0].tickets;
						});
					}
				});
				
			},
			
			onChangeClient(id) {
				
				// Reset project and ticket.
				
				this.projects = [];
				this.tickets = [];
				
				// Find this client's projects.
				
				this.$store.state.clients.map((data, i) => {
					if (data.id == id) {
						this.projects = data.projects;
					}
				});
				
			},
			
			toggleRecording() {
				
				this.$store.commit("toggleTimeBookRecording", {
					
					client_id: this.clientId,
					project_id: this.projectId,
					ticket_id: this.ticketId,
					
					ticket: this.ticket,
					
					project_name: this.project_name,
					
					user_id: this.$auth.user().id,
					
					callback: (e) => {
						
						if (e.state == "success") {
							
							this.$store.commit("theTime");
							
							this.override_client_id = null;
							this.override_project_id = null;
							this.override_ticket_id = null;
							
						}
						
					},
					
				});
				
			}
			
		},
		
	}
	
</script>

<style scoped lang="scss">
	
	.button-wrapper {
		
		float: left;
		
		button {
			
			font-size: 24px;
			width: 48px;
			height: 48px;
			padding: 0;
			
			ion-icon {
				margin-right: 0;
			}
			
		}
		
	}
	
	.dropdowns {
		margin-top: 10px;
	}
	
	.time {
		font-size: 38px;
	    font-weight: 100;
	    line-height: 40px;
	    height: 48px;
	    padding-left: 56px;
	    margin: 0 0 10px 0;
	}
	
	.description {
		opacity: 0.5;
		padding-left: 0;
		margin: 5px 0 0 0;
	}
	
	.description:hover {
		opacity: 1;
	}
	
	.stopwatch--small {
		
		width: 260px;
		
		.button-wrapper button {
			font-size: 16px;
			width: 32px;
			height: 32px;
		}
		
		.time {
			font-size: 30px;
		    line-height: 28px;
		    height: 32px;
		    padding-left: 40px;
		}
		
		.description {
			font-size: 12px;
		}
		
	}
	
	.stopwatch--floating {
		position: absolute;
		bottom: -500px;
		left: 10px;
		padding: 15px;
		transition: all 250ms;
		box-sizing: border-box;
		z-index: 1001;
	}
	
	.stopwatch--floating-visible {
		bottom: 10px;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TimeBook/StopWatch.vue